export const USER_DETAIL_VIEW_TK = "USER_DETAIL_VIEW_TK";
export const USER_CREATE_VIEW_TK = "USER_CREATE_VIEW_TK";
export const USER_CREATE_FORM_TK = "USER_CREATE_FORM_TK";
// cSpell: disable-next-line
export const USER_UPDATE_FORM_TK = "USER_UDPATE_FORM_TK";
export const USER_LIST_VIEW_TK = "USER_LIST_VIEW_TK";
export const USER_LIST_MODAL_TK = "USER_LIST_MODAL_TK";
